
import { types, actions } from './requests'
export const DELETESTDARTICLE_TYPES = {
    ...types('DELETESTDARTICLE'),
}
export const DELETESTDARTICLE_ACTIONS = {
    ...actions('DELETESTDARTICLE'),
}